module.exports = __webpack_public_path__ + "img/link-file-icon.fbc2b22d.svg";